module.exports = __webpack_public_path__ + "static/media/logo1.e79adc36.png";